import { RepositionModes } from "../../util/positioning.js";
/**
 * The position variations for the menu component
 * @public
 */
export const MenuPositions = {
    above: "above",
    below: "below"
};
/**
 * Reposition modes for the menu
 * @public
 */
export const MenuRepositionModes = {
    auto: RepositionModes.auto,
    none: RepositionModes.none
};
//# sourceMappingURL=menu.options.js.map